module.exports = __webpack_public_path__ + "a200851f33a2b23b0f37a41ff512c2ff.png";